var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    stroke: "url(#paint0_linear_13_10210)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12H15",
    stroke: "url(#paint1_linear_13_10210)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V15",
    stroke: "url(#paint2_linear_13_10210)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_10210",
    x1: -17.5714,
    y1: 12,
    x2: 15.8571,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_10210",
    x1: 2.14286,
    y1: 12.5,
    x2: 13.2857,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13_10210",
    x1: 10.8571,
    y1: 12,
    x2: 12.7143,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circlePlus.b05c67b0b53a26a6379436afa3fa9271.svg";
export { ForwardRef as ReactComponent };